import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bc7156c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#5a647e"} }, "忘记密码", -1))
const _hoisted_3 = { style: {"color":"#848485"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "wxlogin" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "myclass"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-login-other" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_lock_outlined = _resolveComponent("lock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_mail_outlined = _resolveComponent("mail-outlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_card_grid = _resolveComponent("a-card-grid")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.customActiveKey == 'tab2' ? 'my_menu_main' : 'my_main', "main"])
  }, [
    _createVNode(_component_a_form, {
      id: "formLogin",
      layout: "vertical",
      class: "user-layout-login",
      autocomplete: "off"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          "active-key": _ctx.customActiveKey,
          "tab-bar-style": { textAlign: 'center', borderBottom: 'unset' },
          onChange: _ctx.handleTabClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "tab1",
              tab: "账号密码登录"
            }, {
              default: _withCtx(() => [
                (_ctx.isLoginError)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      type: "error",
                      "show-icon": "",
                      style: {"margin-bottom":"24px"},
                      message: "账户或密码错误"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.username)), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      size: "large",
                      autocomplete: "off",
                      value: _ctx.modelRef.username,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.username) = $event)),
                      placeholder: "请输入账户",
                      style: {"width":"100%"}
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_user_outlined, { class: "prefixIcon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.password)), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      autocomplete: "off",
                      value: _ctx.modelRef.password,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.password) = $event)),
                      size: "large",
                      placeholder: "请输入密码"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_lock_outlined, { class: "prefixIcon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_a_button, {
                  size: "large",
                  type: "primary",
                  "html-type": "submit",
                  class: "login-button",
                  loading: _ctx.loginBtn,
                  onClick: _ctx.handleLogin,
                  style: {"margin-bottom":"15px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                (_ctx.showMobile)
                  ? (_openBlock(), _createBlock(_component_a_form_item, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          style: {"float":"right"},
                          type: "link",
                          onClick: _ctx.handleNoPassword
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.showMobile)
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "mobile_tab",
                  tab: "手机号登录"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.mobile)), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          autocomplete: "off",
                          size: "large",
                          value: _ctx.modelRef.mobile,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.mobile) = $event)),
                          placeholder: _ctx.$t('请输入手机号'),
                          style: {"width":"100%"}
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_component_user_outlined, { class: "prefixIcon" })
                          ]),
                          _: 1
                        }, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 16),
                    _createVNode(_component_a_form_item, _normalizeProps(_guardReactiveProps(_ctx.validateInfos.code)), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: "16" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  size: "large",
                                  autocomplete: "off",
                                  value: _ctx.modelRef.code,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.code) = $event)),
                                  placeholder: _ctx.$t('请输入验证码'),
                                  style: {"width":"100%"}
                                }, {
                                  prefix: _withCtx(() => [
                                    _createVNode(_component_mail_outlined, { class: "prefixIcon" })
                                  ]),
                                  _: 1
                                }, 8, ["value", "placeholder"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: "8" }, {
                              default: _withCtx(() => [
                                (_ctx.modelRef.num <= 0)
                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                      key: 0,
                                      size: "large",
                                      type: "link",
                                      onClick: _ctx.handleGetCode
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('获取验证码')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_a_button, {
                                      key: 1,
                                      size: "large",
                                      type: "link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('重新获取')) + "(" + _toDisplayString(_ctx.modelRef.num) + "s)", 1)
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16),
                    _createVNode(_component_a_form_item, { style: {"margin-top":"24px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          size: "large",
                          type: "primary",
                          class: "login-button",
                          loading: _ctx.loginBtn,
                          onClick: _ctx.handleMobileLogin
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }, 8, ["loading", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showWx)
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "wx_tab",
                  tab: "微信登录"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      bordered: false,
                      style: {"text-align":"center"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.my_all_menu_list.length > 0)
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "tab2",
                  tab: "选择进入的菜单"
                }, {
                  default: _withCtx(() => [
                    (_ctx.my_all_menu_list.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_a_collapse, {
                            activeKey: _ctx.activeKey,
                            "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeKey) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.my_all_menu_list, (item) => {
                                return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                  key: (item.org?.id).toString(),
                                  header: item.org.name
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_card, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.project_list, (obj) => {
                                          return (_openBlock(), _createBlock(_component_a_card_grid, {
                                            style: {"width":"25%","text-align":"center","padding":"12px"},
                                            key: obj.id,
                                            onClick: ($event: any) => (
                      _ctx.handleGoMenu({
                        org_id: item.org.id,
                        inner_url: obj.inner_url,
                        nexturl: '',
                        link_url: obj.link_url,
                        url_type: obj.url_type,
                      })
                    )
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: obj.icon_url,
                                                height: "50",
                                                width: "50"
                                              }, null, 8, _hoisted_7),
                                              _createElementVNode("div", null, _toDisplayString(obj.name), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["header"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["activeKey"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["active-key", "onChange"]),
        _hoisted_8
      ]),
      _: 1
    })
  ], 2))
}